import gql from 'graphql-tag';

export default gql`
  mutation userGroupDelete($input: UserGroupDeleteInput!) {
    userGroupDelete(input: $input) {
      success
      userErrors {
        field
        message
      }
    }
  }
`;
